import { cn } from "@/lib/utils";
import {
  PendingBatchStatus,
  PendingItemStatus,
  PendingStoreStatus,
} from "@/services/price-remark/types";

import {
  BADGE_BASE,
  BATCH_STATUSES,
  ITEM_SITUATIONS,
  STORE_STATUSES,
} from "./situation-styles";

export function ItemSituationBadge({
  status,
}: {
  status: PendingItemStatus;
}) {
  const style = ITEM_SITUATIONS[status];
  if (!style) return <span className="text-gray-400">—</span>;
  return <span className={cn(BADGE_BASE, style.className)}>{style.label}</span>;
}

export function BatchStatusBadge({
  status,
}: {
  status: PendingBatchStatus;
}) {
  const style = BATCH_STATUSES[status];
  if (!style) return <span className="text-gray-400">—</span>;
  return <span className={cn(BADGE_BASE, style.className)}>{style.label}</span>;
}

export function StoreStatusBadge({
  status,
}: {
  status: PendingStoreStatus;
}) {
  const style = STORE_STATUSES[status];
  if (!style) return <span className="text-gray-400">—</span>;
  return <span className={cn(BADGE_BASE, style.className)}>{style.label}</span>;
}
